import { forwardRef as f, memo as O } from "react";
import { useThemeUI as L } from "theme-ui";
import { areObjectsShallowEqual as b } from "@material-bank/ds-utils";
import { Stack as h } from "../../../Stack/Stack.js";
import { HighlightedText as k } from "../../../Typography/HighlightedText.js";
import "../../../Typography/Text.js";
import { SelectItemIndicator as C } from "./SelectItemIndicator/SelectItemIndicator.js";
import { jsxs as u, jsx as v } from "theme-ui/jsx-runtime";
const M = f((e, r) => {
  const {
    label: d,
    labelHighlightedText: c,
    icon: m,
    selected: o,
    highlighted: n,
    indicatorPlacement: s = "end",
    displayItemIndicator: a = !0,
    reserveIndicatorSpace: p = s === "start",
    disabled: x,
    endContent: i,
    renderItemIndicator: l,
    highlightedSx: w,
    disabledSx: g,
    selectedSx: I,
    ...S
  } = e, {
    theme: t
  } = L();
  return /* @__PURE__ */ u(h, {
    ref: r,
    direction: s === "start" ? "row-reverse" : "row",
    gap: 1,
    ...S,
    sx: {
      ...t.dropdownListItem,
      ...e.sx,
      ...o && {
        ...t.dropdownListSelectedItem,
        ...I
      },
      ...x && {
        ...t.dropdownListDisabledItem,
        ...g
      },
      ...n && {
        ...t.dropdownListHighlightedItem,
        ...w
      }
    },
    children: [/* @__PURE__ */ u(h, {
      direction: "row",
      gap: 1,
      sx: {
        flexGrow: 1
      },
      children: [m, /* @__PURE__ */ v(k, {
        text: d,
        highlightedText: c,
        inherit: !0,
        sx: {
          flexGrow: 1
        }
      })]
    }), i, a && ((l == null ? void 0 : l(o)) ?? /* @__PURE__ */ v(C, {
      selected: o,
      reserveSpace: p
    }))]
  });
});
M.displayName = "SelectItemInner";
const D = O(M, (e, r) => {
  const {
    /* eslint-disable @typescript-eslint/no-unused-vars */
    onMouseDown: d,
    onMouseMove: c,
    onMouseLeave: m,
    onClick: o,
    /* eslint-enable @typescript-eslint/no-unused-vars */
    ...n
  } = e, {
    /* eslint-disable @typescript-eslint/no-unused-vars */
    onMouseDown: s,
    onMouseMove: a,
    onMouseLeave: p,
    onClick: x,
    /* eslint-enable @typescript-eslint/no-unused-vars */
    ...i
  } = r;
  return b(n, i);
});
D.displayName = "SelectItem";
export {
  D as SelectItem
};
